import React from 'react';
import PropTypes from 'prop-types';
import './accordion.module.scss';

const Accordion = ({ children, title }) => (
    <div className={`accordion bg-white`}>
        {title && (
            <div className="d-md-none header text-center font-weight-bold">
                {title}
            </div>
        )}
        {children}
    </div>
);

Accordion.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string
};

export default Accordion;
